module.exports = __webpack_public_path__ + "static/media/logo.2b1087f6.png";